import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { cn } from "utils";
import useApp from "hooks/useApp";

const DashboardLayout = () => {
    const { isSidebarOpen } = useApp();
    return (
        <div className="dashboard container-fluid p-0">
            <div className="app-container d-flex">
                <Sidebar />
                <div className={cn("main-content header-container", isSidebarOpen ? "open" : "closed")}>
                    <Header />
                    <div className="content">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardLayout;
